/**
 * @generated SignedSource<<c85aaca0b2a33a19ce3ca54694c403e7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskOrdersList_viewer$data = {
  readonly transactionsPaginatedSearch: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskOrderTile_transaction">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "GetHelpZendeskOrdersList_viewer";
};
export type GetHelpZendeskOrdersList_viewer$key = {
  readonly " $data"?: GetHelpZendeskOrdersList_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskOrdersList_viewer">;
};

import GetHelpZendeskOrdersListPaginationQuery_graphql from './GetHelpZendeskOrdersListPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "transactionsPaginatedSearch"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "searchTerm"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "viewName"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": GetHelpZendeskOrdersListPaginationQuery_graphql
    }
  },
  "name": "GetHelpZendeskOrdersList_viewer",
  "selections": [
    {
      "alias": "transactionsPaginatedSearch",
      "args": [
        {
          "kind": "Variable",
          "name": "searchTerm",
          "variableName": "searchTerm"
        },
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "viewName",
          "variableName": "viewName"
        }
      ],
      "concreteType": "TransactionsPaginatedSearchConnection",
      "kind": "LinkedField",
      "name": "__OrdersList_transactionsPaginatedSearch_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TransactionsPaginatedSearchEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Transaction",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "GetHelpZendeskOrderTile_transaction"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "1622e7c5eeebd92f9110d4e0c24e0b6f";

export default node;
